import request from '@/utils/request'

//权限相关api
export async function getPerm(data) {
  return request({
    url: '/permission/all',
    method: 'post',
    data,
  })
}
export async function getRolePerm(data) {
  return request({
    url: '/permission/findByRoleId',
    method: 'post',
    data,
  })
}
export async function searchPerm(data) {
  return request({
    url: '/permission/get',
    method: 'post',
    data,
  })
}
export async function createPerm(data) {
  return request({
    url: '/permission/save',
    method: 'post',
    data,
  })
}
export async function updatePerm(data) {
  return request({
    url: '/permission/update',
    method: 'post',
    data,
  })
}
export async function deletePerm(data) {
  return request({
    url: '/permission/delete',
    method: 'post',
    data,
  })
}
